import { Link } from "react-router-dom";
import { SiteFooter as Footer } from "@jkast90/kast-common/ui";
import styles from "./SiteFooter.module.css";

/**
 * The shared footer with this site's links. A page adds its own with
 * `useFooterItems`, or hides it with `useHideFooter`. Report a bug is the shared
 * footer's own; the account, Settings (theme), Sign out and Delete account are on
 * the account page, not here.
 */
export default function SiteFooter() {
  return (
    <Footer
      className={styles.footer}
      collapsible={false}
      legal={{ renderLink: (link) => <Link to={new URL(link.url).pathname}>{link.label}</Link> }}
    >
      <Link to="/other">Other</Link>
    </Footer>
  );
}
